export default __webpack_public_path__ + "static/media/homeabout5.9c2884a9.jpg";